import { createAction, props, union } from '@ngrx/store';

export const addressLookupSuccess = createAction(
  '[YourAddress] Address Lookup Success',
  props<{ newAddress: any }>()
);

export const updateAddress = createAction(
  '[YourAddress] Update Policy Address Details',
  props<{ updatedAddress: any }>()
);

export const updatePostalAddress = createAction(
  '[YourAddress] Update Postal Address Details',
  props<{ updatedPostalAddress: any }>()
);

export const updateParkingDetails = createAction(
  '[YourAddress] Update Overnight Parking Address',
  props<{ updatedParkingDetails: any }>()
);

export const resetAddress = createAction('[YourAddress] Reset Address Only');

export const resetPostalAddress = createAction(
  '[YourAddress] Reset Postal Address Only'
);

export const resetOvernightParking = createAction(
  '[YourAddress] Reset Overnight Parking Address'
);

export const resetAllAddress = createAction(
  '[YourAddress] Reset Both Address and Overnight Parking'
);

export const resetError = createAction('[YourAddress] Reset Error');

// export type YourAddressActionsUnion = ReturnType<typeof addressLookupSuccess | typeof updateAddress | typeof resetError>;

const all = union({
  addressLookupSuccess,
  updateAddress,
  updatePostalAddress,
  updateParkingDetails,
  resetAddress,
  resetPostalAddress,
  resetOvernightParking,
  resetError,
  resetAllAddress,
});
export type YourAddressActionsUnion = typeof all;
